import { defineStore } from 'pinia'
import type { TodoContext } from '@/types'

export const useNotificationActivities = defineStore('notification-activities', {
	state: () => ({
		todo: [
			{
				icon: {
					dir: 'other',
					name: 'personal-card'
				},
				require: 'kyc',
				value: 'Complete KYC for your business',
				type: 'danger'
			}
		] as TodoContext[],
		isActive: false
	}),
	getters: {
		Todo(state) {
			return state.todo
		},
		MyCoverPendingTransactions() {
			return []
		}
	},
	actions: {
		toggle() {
			this.isActive = !this.isActive
		}
	}
})
